import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

// Kolom password dgn tombol ikon mata (tampilkan/sembunyikan) -- dipakai di Login,
// ForcePasswordChange, ResetPassword. Status tampil MURNI state lokal React (bukan
// localStorage/sessionStorage) -- otomatis balik ke default (tersembunyi) tiap
// remount, termasuk reload halaman. Pemanggil yg butuh reset paksa SETELAH submit
// (tanpa reload, mis. login gagal) tinggal ganti prop `key` (lihat Login.jsx) --
// mengganti key me-remount komponen ini & mereset state tampil, tanpa perlu
// prop/API tambahan di sini.
const PasswordInput = forwardRef(({ className, ...props }, ref) => {
    const [visible, setVisible] = useState(false);

    return (
        <div className="relative">
            <Input ref={ref} type={visible ? "text" : "password"} className={cn("pr-10", className)} {...props} />
            <button
                type="button"
                onClick={() => setVisible((v) => !v)}
                aria-label={visible ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"}
                className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring rounded-sm"
            >
                {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
        </div>
    );
});
PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
